// ─────────────────────────────────────────────────────────────────────────────
// Datos simulados para la vista "Recepción en bodega" (drop-off).
//
// MOCKUP: todo lo de este archivo es de demostración. Cuando se conecte el
// backend, reemplazar:
//   - ORDERS            -> getAllPackages/getAdminPackages({ q }) (api/packages.js)
//   - findOrder()       -> la búsqueda real por followingNumber / _id / order_id
//   - el cambio de estado se hace con updatePackageStatus({ id, status: 1 })
//   - BODEGAS           -> catálogo de bodegas de la empresa (gap de backend hoy)
//
// La forma de cada "order" replica el documento real de package
// (followingNumber, order_id, status, receiver_*, shipping_address, senderInfo…).
// ─────────────────────────────────────────────────────────────────────────────

export const STATUS_PENDIENTE = 0;
export const STATUS_RECOLECTADO = 1;

// Clientes / comercios a los que se puede asignar la recepción (mock).
// En producción vendría del catálogo de clientes (store/routes -> fetchClients).
// El match con un pedido se hace por nombre de comercio (comercioName).
export const CLIENTS = [
  { id: "cli-sendu", name: "Sendu Arkal" },
  { id: "cli-aurora", name: "Tienda Aurora" },
  { id: "cli-polar", name: "Distribuidora Polar" },
  { id: "cli-andes", name: "Calzados Andes" },
  { id: "cli-huellitas", name: "Pet Shop Huellitas" },
  { id: "cli-lumen", name: "Cosmética Lumen" },
];

// Bodegas de drop-off (mock). Hoy NO existe entidad bodega en el backend:
// es un punto a definir. Estructura propuesta: { id, name, comuna }.
export const BODEGAS = [
  { id: "bod-centro", name: "Bodega Central — Quilicura", comuna: "Quilicura" },
  { id: "bod-sur", name: "Bodega Sur — San Bernardo", comuna: "San Bernardo" },
  { id: "bod-norte", name: "Bodega Norte — Huechuraba", comuna: "Huechuraba" },
];

let _seq = 1000;
const oid = () => `6650f1a2c3d4e5f6a7b8${(_seq++).toString(16).padStart(4, "0")}`;

// helper compacto: (followingNumber, order_id, status, name, lastName, comuna, address, comercio, phone, type)
const mk = (followingNumber, order_id, status, name, lastName, comuna, address, comercio, phone, type = "Sendu") => ({
  _id: oid(),
  followingNumber: String(followingNumber),
  order_id,
  status,
  type,
  receiver_name: name,
  receiver_lastName: lastName,
  receiver_phone: phone,
  shipping_address: {
    address_line: `${address}, ${comuna}`,
    municipality: { name: comuna.toUpperCase() },
    city: { name: "Santiago" },
    comment: "",
  },
  comments: "",
  packageDimensions: { height: "20", width: "15", length: "10", weight: "1.2" },
  senderInfo: { businessName: comercio, senderAddress: "San Joaquín 123", senderMunicipality: "San Joaquín" },
  senderUser: { senderName: comercio, senderLastName: "", phone: "+56221112222" },
  deliveryInfo: { deliveryBusinessName: "BearTrack" },
  qr: null,
  createdAt: "2026-06-29T11:00:00.000Z",
  updatedAt: "2026-06-29T11:00:00.000Z",
});

// ~28 pedidos. La mayoría Pendiente (0); algunos ya Recolectados (1) o En bodega (2)
// para demostrar el caso "ya estaba recolectado".
export const ORDERS = [
  mk(945172, "SP1464-710088", 0, "Felipe", "Hott Delgado", "Huechuraba", "Cordón de la Cruz 7534", "Sendu Arkal", "+56912345678"),
  mk(945173, "SP1464-710089", 0, "Camila", "Rojas Vera", "Providencia", "Av. Providencia 1240", "Tienda Aurora", "+56987654321"),
  mk(945174, "SP1464-710090", 0, "Matías", "González Pinto", "Las Condes", "Apoquindo 4501", "Distribuidora Polar", "+56911223344"),
  mk(945175, "SP1464-710091", 0, "Valentina", "Muñoz Soto", "Maipú", "Av. Pajaritos 2890", "Calzados Andes", "+56955667788"),
  mk(945176, "SP1464-710092", 0, "Benjamín", "Castro Lagos", "La Florida", "Vicuña Mackenna 7820", "Pet Shop Huellitas", "+56933445566"),
  mk(945177, "SP1464-710093", 0, "Josefa", "Díaz Araya", "Ñuñoa", "Irarrázaval 3450", "Cosmética Lumen", "+56922334455"),
  mk(945178, "SP1464-710094", 0, "Tomás", "Fuentes Reyes", "Santiago Centro", "Huérfanos 1200", "Tienda Aurora", "+56977889900"),
  mk(945179, "SP1464-710095", 0, "Antonia", "Vega Salinas", "Recoleta", "Av. Recoleta 2310", "Sendu Arkal", "+56944556677"),
  mk(945180, "SP1464-710096", 0, "Lucas", "Herrera Núñez", "Puente Alto", "Concha y Toro 1450", "Distribuidora Polar", "+56966778899"),
  mk(945181, "SP1464-710097", 0, "Florencia", "Tapia Bravo", "San Miguel", "Gran Avenida 5120", "Calzados Andes", "+56900112233"),
  mk(945182, "SP1464-710098", 0, "Agustín", "Morales Cortés", "Providencia", "Manuel Montt 980", "Cosmética Lumen", "+56988997766"),
  mk(945183, "SP1464-710099", 0, "Isidora", "Ramírez Flores", "Las Condes", "El Bosque Norte 500", "Pet Shop Huellitas", "+56955443322"),
  mk(945184, "SP1464-710100", 0, "Vicente", "Carrasco Lara", "Maipú", "Tres Poniente 3200", "Tienda Aurora", "+56911998877"),
  mk(945185, "SP1464-710101", 0, "Martina", "Sepúlveda Gómez", "Ñuñoa", "Av. Grecia 1840", "Sendu Arkal", "+56933221100"),
  mk(945186, "SP1464-710102", 0, "Joaquín", "Espinoza Ruiz", "La Florida", "Walker Martínez 2150", "Distribuidora Polar", "+56977665544"),
  mk(945187, "SP1464-710103", 0, "Emilia", "Cáceres Pavez", "Recoleta", "Einstein 850", "Calzados Andes", "+56944332211"),
  mk(945188, "SP1464-710104", 0, "Diego", "Navarrete Silva", "Santiago Centro", "San Diego 1900", "Cosmética Lumen", "+56966554433"),
  mk(945189, "SP1464-710105", 0, "Catalina", "Mella Órdenes", "Puente Alto", "Eyzaguirre 740", "Pet Shop Huellitas", "+56900998877"),
  mk(945190, "SP1464-710106", 0, "Sebastián", "Vargas León", "San Miguel", "Llano Subercaseaux 3400", "Tienda Aurora", "+56988776655"),
  mk(945191, "SP1464-710107", 0, "Trinidad", "Figueroa Paz", "Providencia", "Los Leones 220", "Sendu Arkal", "+56955667711"),
  mk(945192, "SP1464-710108", 0, "Maximiliano", "Riquelme Soto", "Las Condes", "Cerro Colorado 5030", "Distribuidora Polar", "+56911443399"),
  mk(945193, "SP1464-710109", 0, "Renata", "Olivares Cid", "Maipú", "Camino Rinconada 1100", "Calzados Andes", "+56933778822"),
  // Ya recolectados / en bodega -> demuestran "ya estaba recolectado"
  mk(945160, "SP1464-710076", STATUS_RECOLECTADO, "Ignacio", "Bustos Marín", "Ñuñoa", "Dublé Almeyda 3100", "Cosmética Lumen", "+56922118833"),
  mk(945161, "SP1464-710077", 2, "Amanda", "Cornejo Vidal", "La Florida", "Froilán Roa 6800", "Pet Shop Huellitas", "+56977220099"),
  mk(945162, "SP1464-710078", STATUS_RECOLECTADO, "Gabriel", "Saavedra Lobos", "Recoleta", "Zapadores 1200", "Tienda Aurora", "+56944550066"),
];

// Códigos de ejemplo (para el estado vacío / ayuda al operador).
export const SAMPLE_CODES = ["945172", "945173", "945174", "945175"];

// ── Resolución del escaneo ───────────────────────────────────────────────────
// Soporta los 3 formatos que imprime BearTrack hoy y en el rediseño:
//   1. QR JSON  {"id":"<mongoId>"}        (voucher actual / plantilla Zebra)
//   2. URL track .../track/<order_id>     (QR del rediseño)
//   3. Code128 con el followingNumber     (barra 1D del rediseño / a mano)
export function normalizeScan(raw) {
  const s = (raw || "").trim();
  if (!s) return { kind: "code", value: "" };
  if (s.startsWith("{")) {
    try {
      const o = JSON.parse(s);
      if (o && o.id) return { kind: "id", value: String(o.id) };
    } catch (_) { /* no era JSON */ }
  }
  if (s.includes("/track/")) {
    const seg = s.split("/track/")[1]?.split(/[/?#]/)[0];
    if (seg) return { kind: "order_id", value: seg };
  }
  return { kind: "code", value: s };
}

export function findOrder(orders, raw) {
  const n = normalizeScan(raw);
  if (!n.value) return null;
  const v = n.value.toLowerCase();
  return (
    orders.find((o) => {
      if (n.kind === "id") return String(o._id) === n.value;
      if (n.kind === "order_id") return String(o.order_id).toLowerCase() === v;
      return String(o.followingNumber) === n.value || String(o.order_id).toLowerCase() === v;
    }) || null
  );
}

// ── Estado inicial de la sesión (mock) ───────────────────────────────────────
// Siembra una sesión ya iniciada con algunas recepciones recientes para que la
// vista se vea "viva". En producción la sesión arranca vacía.
export function makeInitialState(now) {
  const orders = ORDERS.map((o) => ({ ...o }));
  const startedAt = now - 22 * 60 * 1000;
  const byFollowing = (fn) => orders.find((o) => o.followingNumber === String(fn));

  // pedidos recibidos en esta sesión (los pasamos a Recolectado)
  const recibidos = [945191, 945185, 945179, 945172, 945193].map(byFollowing).filter(Boolean);
  let nextId = 1;
  const session = [];
  recibidos.forEach((o, i) => {
    o.status = STATUS_RECOLECTADO;
    o._recibidoAt = now - (3 + i * 4) * 60 * 1000;
    session.push({
      id: nextId++,
      ts: o._recibidoAt,
      code: o.followingNumber,
      outcome: "success",
      orderId: o._id,
    });
  });
  // un repetido y un no encontrado, para mostrar variedad
  session.push({ id: nextId++, ts: now - 8 * 60 * 1000, code: "945179", outcome: "duplicate", orderId: byFollowing(945179)?._id });
  session.push({ id: nextId++, ts: now - 14 * 60 * 1000, code: "881020", outcome: "notfound", orderId: null });

  session.sort((a, b) => b.ts - a.ts);
  const lastSuccess = session.find((s) => s.outcome === "success");
  return {
    orders,
    session,
    startedAt,
    nextId,
    lastResult: lastSuccess
      ? { outcome: "success", code: lastSuccess.code, orderId: lastSuccess.orderId, ts: lastSuccess.ts }
      : null,
  };
}

// utilidades de presentación
export const recipientName = (o) => [o?.receiver_name, o?.receiver_lastName].filter(Boolean).join(" ") || "—";
export const comercioName = (o) => o?.senderInfo?.businessName || o?.senderUser?.senderName || "—";
export const comunaName = (o) => o?.shipping_address?.municipality?.name || "—";
export const addressLine = (o) => o?.shipping_address?.address_line || "—";
